import React, { ReactElement, useState } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever, Add
} from "@mui/icons-material";

import { 
  Potence,
  TransformOption,
} from "@dndModels";
import { 
  CHARACTER_LEVELS,
} from "@dndModels/Constants";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";

import DisplayObjects from "@dndComponents/display/DisplayObjects";

import SummonStatBlockInput from "@dndComponents/feature/SummonStatBlockInput";
import CreatureLimitInput from "@dndComponents/limitations/CreatureLimitInput";
import ModalOrDrawer from '@components/display/ModalOrDrawer';
import TransformOptionInput from './TransformOptionInput';

interface Props {
  obj: Potence;
  slot_level: number;
  onChange: (changed: Potence) => void;
  onDelete: () => void;
  disabled: boolean;
}

export default function AbilityPotenceTransformInput({ 
  obj,
  slot_level,
  onChange,
  onDelete,
  disabled 
}: Props) {
  const [expanded_option, setExpandedOption] = useState("");

  const renderOption = (option: TransformOption) => {
    return (
      <Grid size={8} key="summary">
        { option.name }
      </Grid>
    );
  }

  const renderExtras = () => {
    return (
      <ModalOrDrawer 
        open={expanded_option !== ""}
        full_page
        onClose={() => setExpandedOption("") }>
        <>
          { renderSelectedOption() }
        </>
      </ModalOrDrawer>
    );
  }

  const renderSelectedOption = () => {
    const option = obj.transform_options.find(o => o.true_id === expanded_option);
    if (option) {
      return (
        <TransformOptionInput
          obj={option}
          slot_level={slot_level}
          disabled={disabled}
          onChange={(changed) => {
            const new_obj = obj;
            const option2 = obj.transform_options.find(o => o.true_id === expanded_option);
            if (option2) {
              option2.copy(changed);
            }
            onChange(new_obj);
          }}
        />
      );
    }
    return (<></>);
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid size={4}>
        <SelectStringBox 
          options={CHARACTER_LEVELS}
          value={`${obj.level}`} 
          name="Level"
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.level = +changed;
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid size={4}>
        <span className="header">
          Options
        </span>
        { !disabled &&
          <Tooltip title={`Add Option`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                const new_obj = obj;
                new_obj.transform_options.push(new TransformOption());
                onChange(new_obj);
              }}>
              <Add/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      <Grid size={4}>
        { !disabled &&
          <Tooltip title={`Delete Potence`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      { obj.transform_options.map((option) => {
        return (
          <Grid size={12} key={option.true_id}
            container spacing={0} direction="row">
            <Grid size={2}>
              <ToggleButtonBox 
                value={option.true_id === expanded_option} 
                name="Expand"
                disabled={disabled}
                onToggle={() => {
                  setExpandedOption(expanded_option === option.true_id ? "" : option.true_id);
                }}
              />
            </Grid>
            { renderOption(option) }
          </Grid>
        );
      })}
      { renderExtras() }
    </Grid>
  );
}
